import getValueReduxUtil from 'modules/redux/utils/get-value'
import getNameReduxUtil from 'modules/redux/utils/get-name'
import getCreatedAtReduxUtil from '@gymaholic/packages/src/modules/redux/utils/get-created-at'

/**
 * @param props
 * @param props.instance
 * @param props.posterUrl
 * @param props.videoUrl
 * @param props.url
 * @param props.description
 * @return {{embedUrl, contentUrl, uploadDate: *, '@type': string, name: *, description: (*), '@context': string, thumbnailUrl: *[]}}
 */
export default function getVideoObjectFromInstanceSchemaUtil (props) {
  const {
    instance,
    posterUrl,
    videoUrl,
    url,
    description
  } = props
  const name = getNameReduxUtil(instance)

  return {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: getNameReduxUtil(instance),
    description: (
      description ||
      getValueReduxUtil(instance, 'description') ||
      getValueReduxUtil(instance, 'note') ||
      `A video that shows how to do ${name}`
    ),
    thumbnailUrl: [
      posterUrl
    ],
    uploadDate: getCreatedAtReduxUtil(instance),
    // 'duration': 'PT1M54S',
    contentUrl: videoUrl,
    embedUrl: url
    // 'interactionStatistic': {
    //   '@type': 'InteractionCounter',
    //   'interactionType': { '@type': 'WatchAction' },
    //   'userInteractionCount': 5647018
    // }
    // "regionsAllowed": "US,NL"
  }
}
